export class DashboardMessage {
  public constructor (
    readonly id: number,
    readonly message: string,
  ) {}

  static createListFromResponse (data: any): Array<DashboardMessage> {
    return data.map((item: any) => {
      return new DashboardMessage(
        item.id,
        item.message
      )
    })
  }
}
